import { render, staticRenderFns } from "./ModifyPassword.vue?vue&type=template&id=a72430a4&scoped=true&"
import script from "./ModifyPassword.vue?vue&type=script&lang=ts&"
export * from "./ModifyPassword.vue?vue&type=script&lang=ts&"
import style0 from "./ModifyPassword.vue?vue&type=style&index=0&id=a72430a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72430a4",
  null
  
)

export default component.exports